
//节点编辑
//中心点平移
//包围盒右上角支持旋转
class IEdit {

    constructor(options) {
        this.options = options || {};
        this.Cesium = options.Cesium || Cesium; //Cesium对象
        this.viewer = options.viewer || viewer; //场景对象
        this.options.style = this.options.style || {};
    }

    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    //创建点
    createPoint(position, style) {
        var $this = this;
        var point = this.viewer.entities.add({
            position: position,
            editGuid: $this.editGuid,
            point: {
                ...style
            }
        });
        return point;
    }
    getSampleHeight(position) {
        //var carto = Cesium.Cartographic.fromCartesian(position);
        //const height = viewer.scene.sampleHeight(carto);
        //viewer.scene.globe.getHeight(carto);// viewer.scene.sampleHeight(carto);

        var cart = viewer.scene.clampToHeight(position);
        var carto = Cesium.Cartographic.fromCartesian(cart);
        const height = carto.height;
        console.log(height);

        return height || 0;
    }
    /**
   * 获取鼠标坐标点
   */
    getCatesian3FromPX(px) {

        // var position = viewer.scene.pickPosition(px);
        // return position;

        var cartesian;
        var ray = this.viewer.camera.getPickRay(px);
        if (!ray) return null;
        cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
        // // var carto = Cesium.Cartographic.fromCartesian(cartesian);
        // var cart = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude, this.getSampleHeight(cartesian));
        // return cart;
        return cartesian;
    }

    getPickEnity(pick) {
        if (Cesium.defined(pick) && (pick.id)) {
            return pick.id;
        }

        return null;
    }
    cart2Wgs84(cartesain3Array) {
        let cartographics = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cartesain3Array);
        return cartographics.map(carto => {
            return [Cesium.Math.toDegrees(carto.longitude), Cesium.Math.toDegrees(carto.latitude)]
        })
    }
    //获取中心点
    getCenter(arr) {
        let centerLonLat = []
        if (arr.length) {
            const lon = []
            const lat = []
            const poly = [];
            for (let i = 0, len = arr.length; i < len; i++) {
                lon.push(arr[i][0])
                lat.push(arr[i][1])
            }
            for (let i = 0, len = lon.length; i < len; i++) {
                poly.push({
                    x: parseFloat(lon[i]),
                    y: parseFloat(lat[i]),
                    z: 0
                });
            }
            const sortedLongitudeArray = poly.map(item => item.x).sort();
            const sortedLatitudeArray = poly.map(item => item.y).sort();
            const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(14);
            const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(14);
            centerLonLat = [Number(centerLongitude), Number(centerLatitude)]
        }
        return centerLonLat;
    }

    //获取外接矩形
    getRectangle(positions) {
        var rectangle = Cesium.Rectangle.fromCartesianArray(positions);
        var west = rectangle.west;
        var south = rectangle.south;
        var east = rectangle.east;
        var north = rectangle.north;

        var topLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(north));
        var topRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(north));
        var bottomLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(south));
        var bottomRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(south));

        return [topLeft, topRight, bottomLeft, bottomRight];
    }

    //获取以center为中心的A和B坐标夹角，有方向
    getAngleCenterPointDir(center, pointA, pointB) {
        //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
        const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
        //求世界坐标到局部坐标的变换矩阵
        const worldToLocal_Matrix = Cesium.Matrix4.inverse(
            localToWorld_Matrix,
            new Cesium.Matrix4()
        );
        //a点在局部坐标的位置，其实就是局部坐标原点
        const localPosition_A = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointA,
            new Cesium.Cartesian3()
        );
        //B点在以A点为原点的局部的坐标位置
        const localPosition_B = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointB,
            new Cesium.Cartesian3()
        );

        //弧度
        const angle1 = Math.atan2(localPosition_A.x - 1, localPosition_A.y - 0);
        const angle2 = Math.atan2(localPosition_B.x - 1, localPosition_B.y - 0);

        const angle = angle2 - angle1;

        //角度
        //let theta = angle * (180 / Math.PI);
        // if (theta < 0) {
        //   theta = theta + 360;
        // }
        return angle;
    }


    //获取以center为中心的A和B坐标夹角，有方向,正常
    getAngleCenterPointDirNor(center, pointA, pointB) {
        //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
        const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
        //求世界坐标到局部坐标的变换矩阵
        const worldToLocal_Matrix = Cesium.Matrix4.inverse(
            localToWorld_Matrix,
            new Cesium.Matrix4()
        );
        //A点在局部坐标的位置
        const localPosition_A = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointA,
            new Cesium.Cartesian3()
        );
        //B点在局部的坐标位置
        const localPosition_B = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointB,
            new Cesium.Cartesian3()
        );

        //弧度
        const angle = this.getAngle(localPosition_A.x, localPosition_A.y, localPosition_B.x, localPosition_B.y);
        //Math.atan2(localPosition_A.x -localPosition_B.x, localPosition_A.y - localPosition_B.y);

        //角度
        let theta = angle * (180 / Math.PI);
        // if (theta < 0) {
        //   theta = theta + 360;
        // }
        return theta;
    }

    //要计算平面坐标系中，两个点和原点形成的夹角，可以使用向量的点积公式。
    getAngle(x1, y1, x2, y2) {
        // 计算两个点之间的向量
        const vector1 = { x: x1 - x2, y: y1 - y2 };
        // 计算原点和第一个点之间的向量
        const vector2 = { x: x1, y: y1 };
        // 计算原点和第二个点之间的向量
        const vector3 = { x: x2, y: y2 };
        // 计算第一个向量和第二个向量的点积
        const dotProduct = vector1.x * vector2.x + vector1.y * vector2.y;
        // 计算第一个向量和第二个向量的模长
        const length1 = Math.sqrt(vector1.x * vector1.x + vector1.y * vector1.y);
        const length2 = Math.sqrt(vector2.x * vector2.x + vector2.y * vector2.y);
        // 计算夹角
        const angle = Math.acos(dotProduct / (length1 * length2));
        return angle;
    }


    //获取以center为中心把point1旋转angle角度后的新坐标，有方向
    getRotateCenterPoint(center, point1, angle) {
        if (angle == 0) {
            return point1;
        }
        // 计算center的地面法向量
        var chicB = Cesium.Cartographic.fromCartesian(center);
        chicB.height = 0;
        var dB = Cesium.Cartographic.toCartesian(chicB);

        var chicC = Cesium.Cartographic.fromCartesian(center);
        chicC.height = 10;
        var dC = Cesium.Cartographic.toCartesian(chicC);

        var normaB = Cesium.Cartesian3.normalize(
            Cesium.Cartesian3.subtract(dB, dC, new Cesium.Cartesian3()),
            new Cesium.Cartesian3()
        );

        // 构造基于center的法向量旋转angle度的矩阵
        var Q = Cesium.Quaternion.fromAxisAngle(normaB, Cesium.Math.toRadians(angle));
        var m3 = Cesium.Matrix3.fromQuaternion(Q);
        var m4 = Cesium.Matrix4.fromRotationTranslation(m3);

        // 计算point1点相对center点的坐标A1
        var A1 = Cesium.Cartesian3.subtract(point1, center, new Cesium.Cartesian3());

        //对A1应用旋转矩阵
        var p = Cesium.Matrix4.multiplyByPoint(m4, A1, new Cesium.Cartesian3());
        // 新点的坐标
        var pointNew = Cesium.Cartesian3.add(p, center, new Cesium.Cartesian3());

        return pointNew;
    }


    /**
    * 计算两个点的方位角度
    * @return {number}
     */
    getAzimuthAngle(pointA, pointB) {

        //以a点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
        const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(pointA);
        //求世界坐标到局部坐标的变换矩阵
        const worldToLocal_Matrix = Cesium.Matrix4.inverse(
            localToWorld_Matrix,
            new Cesium.Matrix4()
        );
        //a点在局部坐标的位置，其实就是局部坐标原点
        const localPosition_A = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointA,
            new Cesium.Cartesian3()
        );
        //B点在以A点为原点的局部的坐标位置
        const localPosition_B = Cesium.Matrix4.multiplyByPoint(
            worldToLocal_Matrix,
            pointB,
            new Cesium.Cartesian3()
        );

        // 求出单位向量
        const vector = new Cesium.Cartesian3(
            localPosition_B.x - localPosition_A.x,
            localPosition_B.y - localPosition_A.y,
            localPosition_B.z - localPosition_A.z
        );
        const unitVector = Cesium.Cartesian3.normalize(vector, new Cesium.Cartesian3());

        // 通过向量的方式计算两个点的夹角，得到角度
        const angleRadians = Math.atan2(unitVector.x, unitVector.y);
        return angleRadians;
    }

    //获取矩形控制点
    getPositionsRectangle(rectangle) {
        var west = rectangle.west;
        var south = rectangle.south;
        var east = rectangle.east;
        var north = rectangle.north;
        var topLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(north));
        var topRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(north));
        var bottomLeft = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(south));
        var bottomRight = Cesium.Cartesian3.fromDegrees(Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(south));

        return [topLeft, bottomRight];
    }
    cartesianToLatlng(cartesian) {
        var latlng = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(cartesian);
        var lat = this.Cesium.Math.toDegrees(latlng.latitude);
        var lng = this.Cesium.Math.toDegrees(latlng.longitude);
        return [lng, lat];
    }

}

export default IEdit;